export const getLanguage = (
  language: IProgrammingLanguage
): ILanguage => ({
  id: language.id,
  name: language.name.toLowerCase(),
  label: `${language.name}`,
  sample_code: language?.sample_code,
  single_line_comment_synatx: language?.single_line_comment_synatx,
});
